// pour charger des versions différentes de langues de momentjs;
// voir ligne 'new webpack.ContextReplacementPlugin(/moment[\/\\]locale$/; /fr|en/);' des fichiers webpack.config.dev (ou prod)
export const DEFAULT_LOCALE = 'fr';
//LOCALES= ['fr'; 'en'];
export const LOCALES = [DEFAULT_LOCALE, 'it', 'es'];



// WEBPACK FOOTER //
// ./src/constants/locale.js